import moment from 'moment'
const Dialogs = {
  namespaced: true,
  state: {
    notifications: [],
    notificationDelay: 100,
    confirmation: {
      show: false,
      title: '',
      message: '',
      buttons: []
    },
    history: {
      status: false,
      data: []
    },
    approveHistory: {
      status: false,
      data: []
    },
    ApprovalD: {
      status: false,
      data: [],
      actions: []
    },
    ApprovalN: {
      status: false,
      message: ''
    }
  },
  mutations: {
    removeNotification (state) {
      if (state.notifications.length > 0) {
        state.notifications.shift()
      }

      setTimeout(() => {
        if (state.notifications.length > 0) {
          state.notifications[0].show = true
        }
      }, state.notificationDelay)
    },
    addNotification (state, payload) {
      const notification = payload
      notification.show = !(state.notifications.length > 0)
      state.notifications.push(notification)
    },
    showConfirmation (state, payload) {
      state.confirmation.title = payload.title
      state.confirmation.message = payload.message
      state.confirmation.buttons = payload.buttons
      state.confirmation.show = true
    },
    closeConfirmation (state) {
      Object.assign(state.confirmation, {title: '', message: '', buttons: [], show: false})
    },
    reset (state, payload) {
      state.notifications = Object.assign([])
      state.confirmation = Object.assign({title: '', message: '', buttons: [], show: false})
    },
    MHistory (state, payload) {
      state.history = payload
    },
    approveHistoryM (state, payload) {
      state.approveHistory = payload
    },
    approvalDStatus (state, payload) {
      state.ApprovalD.status = payload.status
    },
    approvalDData (state, payload) {
      state.ApprovalD.data = payload.data
    },
    approvalDAction (state, payload) {
      state.ApprovalD.actions = payload.actions
    },
    approvalNotification (state, payload) {
      state.ApprovalN = payload
    }
  },
  getters: {
    hasNotifications: (state) => state.notifications.length > 0,
    getHistory: (state) => state.history,
    getApproveHistory: (state) => state.approveHistory,
    getApprovalD: (state) => state.ApprovalD,
    getApprovalN: (state) => state.ApprovalN,
    notification: (state) => state.notifications.length > 0 ? state.notifications[0] : {}
  },
  actions: {
    closeNotification (context) {
      context.commit('removeNotification')
    },
    showNotification (context, payload) {
      context.commit('addNotification', payload)
    },
    showConfirmation (context, payload) {
      context.commit('showConfirmation', payload)
    },
    closeConfirmation (context) {
      context.commit('closeConfirmation')
    },
    setApprovalStatus (context, payload) {
      context.commit('approvalDStatus', payload)
    },
    setApprovalData (context, payload) {
      context.commit('approvalDData', payload)
    },
    setApprovalAction (context, payload) {
      context.commit('approvalDAction', payload)
    },
    setApprovalNotification (context, payload) {
      context.commit('approvalNotification', payload)
    },
    setHistory (context, payload) {
      const vue = payload.vueinstance
      if (payload.Status) {
        return new Promise((resolve, reject) => {
          vue.$backend.dataAudit.getDataAuditTrailByTransIdUsingGET({transId: payload.Id})
            .then(res => {
              let tmp = res.obj.content
              let datav = []
              for (let key in tmp) {
                tmp[key].tittle = tmp[key].remarks
                tmp[key].timef = moment(tmp[key].eventTime).format('DD MMM YYYY HH:mm')
                tmp[key].color = tmp[key].eventType === 'CREATE' ? 'green' : tmp[key].eventType === 'UPDATE' ? 'blue' : 'red'
                tmp[key].icon = tmp[key].eventType === 'CREATE' ? 'add_circle' : tmp[key].eventType === 'UPDATE' ? 'update' : 'delete'
                tmp[key].class = tmp[key].eventType === 'CREATE' ? 'card-create' : tmp[key].eventType === 'UPDATE' ? 'card-update' : 'card-delete'
                datav.push(tmp[key])
              }
              context.commit('MHistory', {status: true, data: datav})
            })
            .catch(err => {
              reject(err)
            })
        })
      } else {
        context.commit('MHistory', { status: false, data: [] })
      }
    },
    setApproveHistory (context, payload) {
      const vue = payload.vueinstance
      if (payload.Status) {
        return new Promise((resolve, reject) => {
          vue.$backend.approval.getApprovalByTransactionIdUsingGET({transid: payload.Id})
            .then(res => {
              context.commit('approveHistoryM', {status: true, data: res.obj})
            })
            .catch(err => {
              reject(err)
            })
        })
      } else {
        context.commit('approveHistoryM', { status: false, data: [] })
      }
    },
    showAlert (context, payload) {
      context.dispatch('showConfirmation',
        {title: payload.title,
          message: payload.message,
          buttons: [{label: 'OK', handler: () => context.dispatch('closeConfirmation')}]})
    },
    reset: (context, payload) => context.commit('reset', payload)
  }
}

export default Dialogs



// WEBPACK FOOTER //
// ./src/store/dialogs/Dialogs.js